module.exports = __webpack_public_path__ + "img/fileImg2.8cac72ca.png";